import { render, staticRenderFns } from "./HeaderNavLink.vue?vue&type=template&id=45a1d282&"
import script from "./HeaderNavLink.vue?vue&type=script&lang=js&"
export * from "./HeaderNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports